$(function () {
    let filters = $('.js-filter'),
        block = $('.js-stock'),
        btn = $('.js-show-all');

    filters.on('change', function () {
        request();
    })
    btn.on('click', function () {
        request();
    });

    function request() {
        let mark = $('.js-filter[name="mark"]').val(),
            model = $('.js-filter[name="model"]').val(),
            power = $('.js-filter[name="power"]').val(),
            price = $('.js-filter[name="price"]').val();

        block.addClass('load');
        btn.addClass('load');

        let action = `/feed_content?page=${window.page}&mark=${mark}&model=${model}&power=${power}&price=${price}`;
        fetch(action, {
            method: 'get',
        })
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {

                if (data) {
                    block.empty();
                    block.append(data);

                    block.removeClass('load');
                    btn.removeClass('load');

                    btn.hide();
                } else {
                }
            })
            .catch(function (error) {
                console.log(`stock error: ${error}`);
            });
    }
})
